import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject, Input, OnInit } from '@angular/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCheck, faTimes } from '@fortawesome/pro-solid-svg-icons';
import { Observable } from 'rxjs';

import { FileForDownloadComponent } from '@nexweb/shared/ui/file-view-for-download';
import { CypressNamePipe } from '@nexweb/shared/ui/pipes/cypress-name';
import { SafeHtmlPipe } from '@nexweb/shared/ui/pipes/safe-html';

import { GridColumn, GridColumnTypes, GridInputTypes, TooltipSettings } from '../models';
import { TooltipTitlePipe } from '../pipes';
import { GridColumnFormatPipe } from '../pipes/grid-column-format.pipe';
import { ColumnService } from '../services';

@Component({
  selector: 'nexweb-column',
  standalone: true,
  templateUrl: './column.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TooltipTitlePipe,
    CypressNamePipe,
    GridColumnFormatPipe,
    FaIconComponent,
    FileForDownloadComponent,
    SafeHtmlPipe,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ColumnComponent implements OnInit {
  @Input() dataItem: unknown;
  @Input() column!: GridColumn;
  @Input() toolTipVisible!: boolean;

  gridInputTypes = GridInputTypes;
  //gridCommandTypes = GridCommandTypes;
  gridColumnTypes = GridColumnTypes;

  public faCheck = faCheck;
  public faTimes = faTimes;

  private columnService = inject(ColumnService);

  ngOnInit(): void {
    if (this.column.tooltip === true || (<TooltipSettings>this.column.tooltip)?.visible === true) {
      this.toolTipVisible = true;
    }
  }

  /**
   * Get Selected value Item
   *
   * @param dataItem
   * @param column
   * @returns
   */
  public getSelectDataItemValue(dataItem: unknown, column: GridColumn): Observable<unknown> {
    return this.columnService.getSelectDataItemValue(dataItem, column);
  }

  /**
   * Get Selected value Item
   *
   * @param dataItem
   * @param column
   * @returns
   */
  public getMultiSelectDataItemValue(dataItem: unknown, column: GridColumn): Observable<unknown> {
    return this.columnService.getMultiSelectDataItemValue(dataItem, column);
  }

  /**
   * getDataItemValue
   */
  public getDataItemValue(dataItem: unknown, column: GridColumn): unknown {
    return this.columnService.getDataItemValue(dataItem, column);
  }

  /**
   * Column template
   * @param template
   * @param column
   * @param dataItem
   */
  getAsTemplate(
    template: (column?: GridColumn, dataItem?: unknown) => string | Observable<string>,
    column: GridColumn,
    dataItem: unknown,
  ): string {
    return this.columnService.getAsTemplate(template, column, dataItem) as string;
  }

  /**
   * File Template
   * @param dataItem
   * @param column
   * @returns
   */
  public getDataFileSelectValue(dataItem: unknown, column: GridColumn): File[] {
    return this.columnService.getDataFileSelectValue(dataItem, column);
  }
}
